/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum UserStatusApiModel {
  Deleted = 'deleted',

  Blocked = 'blocked',

  Banned = 'banned',

  Suspended = 'suspended',

  Registered = 'registered',

  Active = 'active'
}
